import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '30px 10px',
    backgroundColor: 'rgb(239, 242, 247)',
    backgroundImage: (props as any).backgroundImage,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '30%',
  }),
  container: {
    width: '100%',
    maxWidth: 650,
    margin: '0 auto',
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    [theme.breakpoints.down(520)]: {
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  btnWrapper: {
    padding: 10,
  },
  completeBtn: {
    background: theme.custom.accept,
  },
  rejectBtn: {
    background: theme.custom.warning,
  },
  form: {
    marginBottom: 20,
  },
  formTitle: {
    margin: 0,
    marginBottom: 10,
    fontSize: 16,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  valuesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    background: '#F2F4F8',
  },
  ul: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  li: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 10,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  col: {
    flexDirection: 'column',
  },
  colLabel: {
    marginRight: 0,
    marginBottom: 5,
  },
  label: {
    fontSize: 14,
    marginRight: 30,
    color: '#646464',
  },
  formLabel: {
    marginBottom: 15,
    fontSize: 14,
    color: '#646464',
  },
  value: {
    fontSize: 14,
    color: theme.custom.darkBlue,
    wordBreak: 'break-word',
  },
  viewWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  textarea: {
    display: 'block',
    width: '100%',
    minHeight: 100,
    padding: 9,
    border: '1px solid rgba(34, 64, 96, .2)',
  },
  textareaError: {
    borderColor: theme.custom.warning,
  },
  infoIcon: {
    marginRight: 10,
    fontSize: 14,
    color: '#224060',
  },
}));
